/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface DatasetPolymorphicSingleTurnChatDataset
 */
export interface DatasetPolymorphicSingleTurnChatDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof DatasetPolymorphicSingleTurnChatDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof DatasetPolymorphicSingleTurnChatDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof DatasetPolymorphicSingleTurnChatDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPolymorphicSingleTurnChatDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof DatasetPolymorphicSingleTurnChatDataset
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPolymorphicSingleTurnChatDataset
   */
  groundTruthIsExhaustive?: boolean;
}

/**
 * Check if a given object implements the DatasetPolymorphicSingleTurnChatDataset interface.
 */
export function instanceOfDatasetPolymorphicSingleTurnChatDataset(
  value: object,
): value is DatasetPolymorphicSingleTurnChatDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function DatasetPolymorphicSingleTurnChatDatasetFromJSON(json: any): DatasetPolymorphicSingleTurnChatDataset {
  return DatasetPolymorphicSingleTurnChatDatasetFromJSONTyped(json, false);
}

export function DatasetPolymorphicSingleTurnChatDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DatasetPolymorphicSingleTurnChatDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    groundTruthIsExhaustive:
      json['ground_truth_is_exhaustive'] == null ? undefined : json['ground_truth_is_exhaustive'],
  };
}

export function DatasetPolymorphicSingleTurnChatDatasetToJSON(
  value?: Omit<DatasetPolymorphicSingleTurnChatDataset, 'id' | 'hasPredictions'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    ground_truth_is_exhaustive: value['groundTruthIsExhaustive'],
  };
}
